import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseCrudComponent } from '../../base';
import * as FileSaver from 'file-saver';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'upload-excel',
  template: `
  <div class="ui-g-12 ui-md-12 ui-lg-2">
      <button pButton aria-hidden="true" (click)="exportarXls()" class="ui-button-mandalay"
        icon="fa ui-icon-description" iconPos="left" pTooltip="Exportar para Excel" label="Excel"></button>
    </div>
  `
})
export class UploadExcelComponent extends BaseCrudComponent {

  @Input() Dados: FormGroup;
  @Input() controller: string;
  @Input() arquivoNome: string;
  
  //@Output()listaAnexoChange=new EventEmitter<any[]>();
  init() {
  }

  exportarXls() {
    this.Dados.value.id_lotacao = localStorage.getItem('lotacao');

    this.confirmacao.confirm({
      header: 'Confirmação',
      message: `Deseja realmente exportar esses registros para Excel?`,
      accept: () => {
        this.observableUtilPanelDoc.setBlockedPanel(true);
        this.service.ObterExcel(this.Dados.value, this.controller, 'gerarExcel', null).subscribe(
          x => {
            const nomeArquivo = this.arquivoNome ? this.arquivoNome : 'Consulta.xlsx';
            FileSaver.saveAs(new Blob([x.blob()], { type: x['_body'].type }), nomeArquivo);
            this.showMsg('success', 'Mensagem de Sucesso', `Capacitadora foi impressa com sucesso.`);
            this.observableUtilPanelDoc.setBlockedPanel(false);
          },
          err => {
            this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao imprimir a Capacitadora. ${err}`);
            this.observableUtilPanelDoc.setBlockedPanel(false);
          }
        );
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/Componentes/upload-excel/upload-excel.component.ts